<template>
    <div>
        <div class="row">
            <div class="row">
                <div class="col-md-4">
                    <h2>{{ getTranslation('lbl_customer_create_headline') }} </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <form @submit.prevent="addcustomer">
                        <div class="form-group">
                            <label for="name">{{ getTranslation('lbl_customer_name') }} *</label>
                            <input
                                    type="text"
                                    id="name"
                                    class="form-control"
                                    formControlName="name"
                                    v-model="customer.name">
                        </div>
                        <div class="form-group">
                            <label for="code">{{ getTranslation('lbl_customer_code') }} *</label>
                            <input
                                    maxlength="4"
                                    type="text"
                                    id="code"
                                    class="form-control"
                                    formControlName="code"
                                    v-model="customer.code">
                        </div>
                        <div class="form-group same-row-spaced-apart-aligned" style="margin-top: 2.5rem;">
                            <label style="margin-bottom: 0 !important;">{{ getTranslation('lbl_customer_active') }}</label>
                            <app-switch :autoSave="false" :isInList="false" identification="active" v-model="customer.active"></app-switch>
                        </div>
                        <div class="divider"></div>
                        <button class="btn btn-primary" type="submit" >
                            {{ getTranslation('app_lbl_action_customer_create') }}
                        </button>
                        <button class="btn pull-right" type="button" @click.prevent="goBack()">
                            {{ getTranslation('app_lbl_action_cancel') }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import { customerMixin } from '../../../../Banet/mixins/customerMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';
    import Switch from '../../../public/components/Switch.vue';

    export default {
        mixins: [ translationMixin, customerMixin, clickaway ],
        created: function(){
            const id = (this.$route.params.id) ? this.$route.params.id : null;
            this.getCustomers(id);
        },
        components: {
          appSwitch: Switch
        },
        sockets:{
            customerChanged: function(){
                const backUrl = (this.isClient) ? '/' : `/client/${this.customer.client}`;
                this.$route.meta.activeTab = 4;  // setting active tab when adding user and going back on client-page
                this.$router.push(backUrl);
            },
            sameCustomerExist: function(sameCustomer) {
              if (sameCustomer != null) {
                 if(sameCustomer.name === this.customer.name){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_customer_name_exists' } );
                 }
                 if(sameCustomer.code === this.customer.code){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_customer_code_exists' } );
                 }
              } else {
                 this.setUser();
              }
            },
            message: function (msg) {
                mainEventBus.$emit('alert', {type: msg.type, msg: msg.msg});
            },
        },
        data: function () {
            return {
                customer: {
                    name: '',
                    code: '',
                    active: false,
                    client: null,
                },
                required: [
                    { name: 'name', found: false },
                    { name: 'code', found: false },
                ]
            }
        },
        methods: {
            gotoLogin: function(){
//                this.$router.push('/login');
            },
            addcustomer: function(){
                if(this.isClient) {
                  this.user.role = 'client-admin';
                } else if(this.isAdmin) {
                  this.user.role = 'admin';
                }
                for (let i in this.customer) {
                    if (typeof(this.customer[i]) === 'string') {
                        this.customer[i] = this.customer[i].trim();
                    }
                    for (let j in this.required) {
//                        this.required[j].found = false;
                        if (i === this.required[j].name) {
                            if (this.customer[i] !== '') {
                                this.required[j].found = true;
                            }
                        }
                    }
                }
                for (let i in this.required) {
                  if (this.required[i].found === false) {
                     mainEventBus.$emit( 'alert', { type:'warning', msg:'error_' + this.required[i].name + '_required' } );
                     for (let i in this.required) {
                        this.required[i].found = false;
                     }
                     return false;
                  }
                }
                if(this.findInCustomers('name', this.customer.name)){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_customer_name_used' } );
                    return false;
                }
                if(this.findInCustomers('code', this.customer.code)){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_customer_code_used' } );
                    return false;
                }
                this.customer.client = (this.$route.params.id) ? this.$route.params.id : null;
                this.setCustomer();
            },
            setCustomer(){
               this.$socket.emit('customerCreate', this.customer);
            },
            goBack: function(){
                if (this.$route.params.id ||
                    (this.$store.getters.getRole === 'user' || this.$store.getters.getRole === 'client')) {
                    this.$route.meta.isClientAdmin = true;
                } else {
                    this.$route.meta.isClientAdmin = false;
                }

                const redirectURL = (this.$route.meta.isClientAdmin) ? `/client/${this.$route.params.id}` :
                    '/customers';
                this.$route.meta.activeTab = 4;
                this.$router.push(redirectURL);
            },
        }
    }
</script>


<style scoped>
  .same-row-spaced-apart-aligned { display: flex; justify-content: space-between; align-items: center; }
</style>


// WEBPACK FOOTER //
// CustomerCreate.vue?507642e0